import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/templates';
const endPointV1 = getUrl('backend') + '/api/v1/templates';

export const getPublicTemplate = ({ supplier }) =>
  axios
    .get(endPoint.concat('/supplier/', supplier), {
      timeout: 10000,
    })
    .then((res) => res)
    .catch((error) => error.response);

export const getPublicTemplates = async ({
  page,
  size,
  sort,
  filters: { pid, ...filters },
}) => {
  return axios
    .get(endPoint.concat('/', getQueryData(page, size, filters)))
    .then((res) => {
      return { ...res, data: { ...res.data, templates: res.data.data } };
    })
    .catch((error) => {
      return error.response;
    });
};

export const getPublicTemplateById = ({ id }) =>
  axios
    .get(endPoint.concat('/', id), {
      timeout: 10000,
    })
    .then((res) => res)
    .catch((error) => error.response);

export const createPublicTemplate = async (template) =>
  axios
    .post(endPointV1.concat('/'), template, {})
    .then((res) => res)
    .catch((error) => error.response);

export const updatePublicTemplate = (template) =>
  axios
    .put(endPointV1.concat('/', template.id), template, {})
    .then((res) => res)
    .catch((error) => error.response);

export const deletePublicTemplate = (id) =>
  axios
    .delete(endPoint.concat('/', id), {})
    .then((res) => res)
    .catch((error) => error.response);

export const copyPublicTemplate = ({ name, pid, id }) =>
  axios
    .post(endPoint.concat('/clone/', id), { name, pid })
    .then((res) => res)
    .catch((error) => error.response);
